import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

export default defineType({
  title: 'Testimonial',
  name: 'testimonial',
  type: 'object',
  fields: [
    defineField({
      title: 'Photo',
      name: 'photo',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: strongEmLink,
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      title: 'Author',
      name: 'author',
      type: 'string',
    }),
  ],
})